import type { ApplyPaymentRequest, ApplyPaymentResponse } from '@/types/payment.types';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axios from 'axios';
import type { GenericErrorResponse } from '@/types/api.types';

export const applyPaymentApi = async (data: ApplyPaymentRequest): Promise<ApplyPaymentResponse> => {
  const response = await axios.post<ApplyPaymentResponse>('/payments/apply', data);
  return response.data;
};

export const useApplyPayment = (
  options?: Omit<UseMutationOptions<ApplyPaymentResponse, GenericErrorResponse, ApplyPaymentRequest>, 'mutationFn'>
) => {
  return useMutation<ApplyPaymentResponse, GenericErrorResponse, ApplyPaymentRequest>({
    mutationFn: applyPaymentApi,
    ...options,
  });
};

